 export const serverError='Une erreur est survenue.'
 export const cnx='Connexion réseau perdue.'
 export const successCreateTest = 'Compétences ont été ajouté avec succès'
 export const successCreateTestEsn = 'Test ajouté avec succès'
 export const linkdinExist = 'Le Linkedin a été déjà utilisé.' 
 export const responsableexist="Cette entreprise dispose déjà d'un responsable !."
 export const errormailexit='votre mail déja existe .'
export const sessionExpired='session expirée.'
export const minCompetence = 'Il faut selectionner au moins une compétence'
export const maxCompetence = 'vous devez sélectionner maximum 5 compètences'
export const welcomeMessage='Bienvenue sur votre espace Wegestu'
export const noAccountMail='Pas de compte associé à cette adresse e-mail.'
export const invalidMailPassword='Adresse e-mail ou mot de passe invalide.'
export const invalidMail='Pas de compte associé à cette adresse e-mail.'
export const permissionDenied='Vous n\'avez pas le droit d\'exécuter cette action.'
export const calloffererreur='Veuillez remplir les champs obligatoires'
export const emailSended='Email envoyé avec succès .'
export const emailExist='L\'adresse e-mail professionel a déjà été utilisée.'
export const nameExist='Nom a déjà été utilisée.'
export const emailcontactExist='email a déjà été utilisée.'
export const succesdisassociateConsultant = 'Consultant dissocier avec succés.'
export const linkedincontactExist='Linkedin a déjà été utilisée.'
export const personalEmailExist='L\'adresse e-mail personnel a déjà été utilisée.'
export const formulaireremplir='svp remplir votre formulaire.'
export const successRegister='Inscription avec succès '
export const successCodeVerficiation='Email vérifié avec succès'
export const invalidVerificationCode='Code erroné'
export const notVerifiedEmail="Email n'est pas vérifié"
export const codeSended="code envoyé"
export const Successpage = 'le paramétrage de pages a été modifié avec succès.'
export const noAccountCandidateMail='Pas de compte entreprise associé à cette adresse e-mail.'
export const usedmail='adresse e-mail utilisé essaye une nouvelle'
export const existPhoneNumber='Numéro de téléphone utilisé essaye une nouvelle'
export const successEditProfile='Le profil a été modifié avec succès.'
export const successAddBareme='Le baréme a été ajouté avec succès.'
export const SuccessAssign='Permission(s) assignée(s)/désassignée(s) avec succès.'
export const successAddSkills='Compétence ajouté avec succée'
export const FormInvalid ='Champs manquants'
export const changePasswordSuccess='Le mot de passe est changé avec succès'
export const changedPassword='Votre mot de passe a été changé avec succée.'
export const logoutMessage='Voulez-vous vraiment vous déconnecter de votre espace Wegestu?'
export const successEvaluation='Votre évaluation a été ajoutée avec succès.'
export const EmptyCV='Ce candidat ne disposant pas d\'un curriculum vitae.'
export const EmptyReponse='Les candidats sélectionnés ne disposent pas des réponses.'
export const noCvSelected='Les candidats sélectionnés ne disposent pas de CV.'
export const noTestFileSelected='Les candidats sélectionnés ne disposent pas des réponses.'
export const obligationSelect='Vous devez selectionner au moins un candidat.'
export const blockSuccess="L'entreprise a été bloquée avec succès.."
export const deblockSuccess="L'entreprise a été débloquée avec succès."
export const dejabloque="Entreprise deja bloqué"
export const addedIntervenant='Intervenant ajouté avec succès.'
export const addedCra='L\'activité  a été ajoutée avec succès.'
export const updatedCra='L\'activité a été modifiée avec succès.'
export const deletedCra='L\'Activité a été supprimée avec succès.'
export const existedCra='L\'activité existe déjà.'
export const associatedIntervenant='L\'intervenant est déjà associé à une autre entreprise.'
export const associatedIntervenant2='L\'intervenant est déjà associé à cette entreprise.'
export const associatedIntervenant1='cet e-mail existe déjà.'
export const updatedIntervenant='Intervenant modifié avec succès.'
export const phoneNumberExist='Le numéro de téléphone a déjà été utilisé.'
export const existedIntervenant='Un intervenant comprenant ce nom existe déja.'
export const confirmDelete='Voulez-vous vraiment supprimer'
export const failedDelete='Supression échouée.'
export const successDelete='Supression avec succès .'
export const emptyFileTest='Ce candidat ne disposant pas d\'un fichier test.'
export const successEvaluationupdate = "Votre évaluation est modifié avec succès"
export const addedExternalConsult = "Consultant ajouté avec succès"
export const associatedConsult = "Consultant associé au client."
export const associatedautreConsult = "Consultant associé à un autre client."
export const contactintrouvable="entreprise pas de responsable"
export const contactintrouvablecalloffer="Aucun responsable n'est désigné pour cet appel d'offre."

export const callofferajout="L’appel d’offre a été ajouté avec succès."
export const calloffermodifie="appel offre modifié avec succès"
export const addedchapitre='chapitre evalution  ajouté avec succès.'
export const existedchapitre='Un chapitre evaluation comprenant ce nom exist déja.'
export const passwordsCompare="L’ancien et le nouveau mot de passe ne peuvent pas être les mêmes."
export const inexistedConsultantEsn="Cette ESN ne dispose pas des consultants."
export const successSignature = "Votre signature est envoyé avec succès"
export const successTimesheet="Votre Timesheet est ajouté avec succès"
export const sendEvaluation="Votre évaluation est envoyé avec succès "
export const existedRole='Le rôle existe déja.'
export const deletedRole='Le rôle a été supprimé avec succès.'
export const existedManager='L\'entreprise a déjà un responsable.'
export const invalidSelectedDate='La date sélectionnée est dans le futur, veuillez choisir une autre date.'
export const checkRequiredInputs='Vous devez remplir les champs obligatoires !'
export const greaterTjm='TJM est supérieur au salaire brut souhaité.'
export const noThingChanged='Vous n\'avez effectué aucun changement.'
export const successAddworkfloww='WorkFlow a été ajoutée avec succès.'
export const successupdateworkfloww='WorkFlow a été modifié avec succès.'
export const addQuestion='La question a été ajoutée avec succès.'
export const existedQuestion='La question existe déja'
export const existedResponse='Il n\'est pas possible d\'ajouter la même réponse à une question.'
export const updatedQuestion='La question a été modifiée avec succès.'
export const deletedQuestion='La question a été supprimée avec succès.'
export const deletechapitre='Sujet évaluation a été supprimé..'
export const successDeletequestion=' Question a été supprimé avec succès.'
export const confirmBaremeMsg='Voulez-vous ajouter un barème pour l\'appel d\'offre?'
export const maxSizeFile='Le fichier à importer ne doit pas depasser 2 méga !'
export const fileTypeExtention='Format fichier non compatible !'
export const successEditProfileadmin='Entreprise a été modifié avec succès.'
export const salaryalreadyassociated='Déjà associé à ce client en tant que salaire.'
export const emplyeealreadyassociated='Déjà associé à ce client en tant qu’employé.'
export const suplieralreadyassociated='Fournisseur déjà associé à ce client.'
export const consultantalreadyassociated='Déjà associé à ce client en tant que consultant externe.'
export const oldPassword='L’ancien mot de passe est incorrect.'

export const oldEmail="L'email est associ\u00e9 \u00e0 un autre utilisateur"
export const addedEvaluation = 'L\'évaluation a été ajoutée avec succès.'
export const updatedEvaluation = 'L\'évaluation a été modifiée avec succès.'
export const deletedEvaluation = 'L\'évaluation a été supprimée avec succès.'
export const existedEvaluation = 'Le nom de template existe déja.'
export const CraWorkflowLinkedRole = ' Ce rôle est lié à un workflow CRAS et ne peut pas être modifié. '
export const loginExceedsSessionsNumber = 'Vous avez atteint le nombre maximal de sessions ouvertes (5). Veuillez fermer une session avant de vous reconnecter.'